import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
import { StyledButton as Button } from '../../../common/Button'
import { BlockEditOptionsContainer } from './BlockOptionsContainers'
import { withTranslation } from 'react-i18next'
import Menu from '../../../common/Menu'

export const BlockEditOptions = ({
  layer,
  removeBlocks,
  sendToFront,
  sendToBack,
  t
}) => (
  <Fragment>
    <Button onClick={sendToFront} stretch inactive={layer === 'front'}>
      {t('blockOptions.moveToFront')}
    </Button>
    <Button onClick={sendToBack} stretch inactive={layer === 'back'}>
      {t('blockOptions.moveToBack')}
    </Button>

    <Menu.Divider />

    {/* <Button onClick={}>{t('blockOptions.duplicate')}</Button> */}
    <Button onClick={removeBlocks}>{t('blockOptions.delete')}</Button>
  </Fragment>
)

BlockEditOptions.propTypes = {
  layer: PropTypes.string,
  removeBlocks: PropTypes.func.isRequired,
  sendToFront: PropTypes.func.isRequired,
  sendToBack: PropTypes.func.isRequired,
  queueBlocks: PropTypes.func.isRequired
}

export default BlockEditOptionsContainer(withTranslation()(BlockEditOptions))
